"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");

// A custom theme for this app
var theme = (0, _styles.createMuiTheme)({
  palette: {
    primary: {
      main: '#0053a0',
      dark: '#003566'
    },
    secondary: {
      main: '#ffb836'
    },
    tertiary: {
      main: '#e31c3d',
      black: '#333',
      white: '#fff',
      muted: '#f7f7f7',
      grey: '#e7e7ea',
      border: '#707070'
    },
    text: {
      primary: '#333333',
      secondary: '#ffffff',
      disabled: '#f7f7f7',
      hint: '#f7f7f7'
    },
    warning: {
      main: '#e31c3d'
    },
    background: {
      default: '#fff'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 639,
      md: 768,
      lg: 1024,
      xl: 1670
    }
  },
  spacing: 10,
  typography: {
    h2: {
      fontSize: '18px',
      fontWeight: 400
    },
    body2: {
      fontSize: '16px',
      fontWeight: 600
    }
  },
  overrides: {
    MuiCardHeader: {
      root: {
        position: 'absolute',
        right: 0
      }
    },
    MuiFormLabel: {
      root: {
        paddingLeft: 10,
        fontSize: 15,
        color: '#585860'
      }
    },
    MuiButton: {
      outlinedPrimary: {
        border: '2px solid',
        fontSize: 16,
        borderRadius: 5,
        '&:hover:not($disabled)': {
          border: '2px solid'
        }
      }
    },
    MuiSelect: {
      root: {
        border: '1px solid #333',
        padding: 10
      },
      selectMenu: {
        height: 28,
        display: 'flex',
        alignItems: 'center',
        fontSize: 15,
        minWidth: 336
      },
      icon: {
        right: 5
      }
    }
  }
}); //  This needs to be added somewhere to enable custom color props
// theme.palette.tertiary = theme.palette.augmentColor({
//   main: "#e31c3d"
//   });

var _default = theme;
exports.default = _default;